import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailInfoboxComponent } from '../../components/email-infobox/email-infobox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-rescheduled-event-notification-template',
  styleUrls: ['../../global-styles.less', './rescheduled-event-notification.component.less'],
  templateUrl: './rescheduled-event-notification.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
    EmailInfoboxComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class RescheduledEventNotificationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<RescheduledEventNotificationTemplateData>;
}

export type RescheduledEventNotificationTemplateData = {
  title: string;
  rescheduled_by_html: string;
  rescheduled_reason_html: string;
  updated_label: string;
  former_label: string;
  when_label: string;
  starts_at_html: string;
  starts_at_timezone: string;
  old_starts_at_html: string;
  old_starts_at_timezone: string;
  reschedule_label: string;
  reschedule_link: string;
  reschedule_link_url: string;
  interviewers_label: string;
  interviewers: string;
  candidate_label: string;
  candidate: string;
  candidate_url: string;
  event_label: string;
  event_url: string;
  public_note_label: string;
  public_note: string;
  private_note_label: string;
  private_note: string;
  footer: string;
};

export const RescheduledEventNotificationTemplateMocks: RescheduledEventNotificationTemplateData[] =
  [
    {
      title: 'On-site interview',
      rescheduled_by_html: 'The event has been rescheduled by <b>Anika Patel</b>',
      rescheduled_reason_html:
        '<b>Reason for change:</b></br>I’m sorry, I need to change the time because my mother is in hospital',
      updated_label: 'Updated:',
      former_label: 'Former:',
      when_label: 'When',
      starts_at_html: '<b>Thrusday</b>, 28 September 2017 at <b>8:00 - 9:00</b>',
      starts_at_timezone: 'America/New York (-4:00)',
      old_starts_at_html: '<b>Friday</b> 8 April 2022 at <b>14:00 - 15:00</b>',
      old_starts_at_timezone: 'America/New York (-4:00)',
      reschedule_label: "Can't make it?",
      reschedule_link: 'Reschedule',
      reschedule_link_url: 'http://recruitee.com',
      interviewers_label: 'Interviewers',
      interviewers: 'Jacek Buczek, Melon Plusk, Kate Watson',
      candidate_label: 'Candidate',
      candidate: 'Bruce Banner',
      candidate_url: 'http://recruitee.com',
      event_label: 'Event link',
      event_url: 'http://recruitee.com',
      public_note_label: 'Note',
      public_note: 'If you have any questions please send us email or message to 918-182-123',
      private_note_label: 'Private note',
      private_note: 'Lives outside Amsterdam. High salary expectations.',
      footer: 'test_footer',
    },
  ];
